import styles from "./sectionRegion.module.scss";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import RegionDescription from "./components/RegionDescription/RegionDescription";
import StatesSectionNew from "../StatesSection/index";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";

type SectionRegionElementsProps = {
  isDesktop?: boolean;
};

const SectionRegionElements = ({ isDesktop = false }: SectionRegionElementsProps) => {
  const { region, isCountry, stateList } = useSelector(
    ({ searchPageData }: AppState) => ({
      region: searchPageData.region,
      isCountry: searchPageData.regionList.isCountry,
      stateList: searchPageData.regionList.stateList,
    }),
    shallowEqual,
  );
  const { t } = useTranslationHook();

  return (
    <div className={styles.sectionRegionContainer}>
      <RegionDescription
        region={region}
        titleText={`${t("searchpage.components.sectionregionelements.studenttext")} ${
          ["United States", "Canada"].includes(region?.location?.country?.long_name)
            ? t("searchpage.components.sectionregionelements.housingtext")
            : t("searchpage.components.sectionregionelements.accommodationstext")
        } ${t("searchpage.components.sectionregionelements.intext")}`}
        isDesktop={isDesktop}
        className={styles.commonSection}
      />

      {isCountry && stateList.length > 0 && (
        <StatesSectionNew
          countryName={region?.name || ""}
          stateList={stateList}
          isDesktop={isDesktop}
          className={styles.commonSection}
        />
      )}
    </div>
  );
};

export default wrapperHOC(SectionRegionElements, {
  componentName: "SectionRegionElements-SearchPage",
  showForChina: true,
});
